package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCheck
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.state.AppState
import io.horion.cv.styles.FeatureIconStyle
import io.horion.cv.styles.FeatureTextStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun FeautureItem(
    text: String,
    modifier: Modifier = Modifier
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val textColor = if (isDark) Colors.LightGray else Colors.DarkBlue

    Row(
        modifier = Modifier.gap(12.px).then(modifier),
        verticalAlignment = Alignment.CenterVertically,
    ) {

        FaCheck(
            modifier = FeatureIconStyle.toModifier()
                .styleModifier {
                    property("filter", if (isDark) "brightness(1.5)" else "none")
                }
        )

        P(
            attrs = FeatureTextStyle.toModifier()
                .fontFamily(INTER)
                .color(textColor)
                .margin(0.px)
                .whiteSpace(WhiteSpace.PreWrap)
                .toAttrs()
        ) {
            Text(text)
        }
    }
}

